import React, { useEffect, useState } from "react";
import {
    Form,
    Row,
    Col,
    Button,
    Card,
    Modal,
} from "react-bootstrap";
export default function AddSessionModal({
    showSessionModal, closeSessionModal, newSession,
    sessionErrors, setNewSession, saveSession, setSessionErrors
}) {
    return (
        <Modal
            show={showSessionModal}
            onHide={closeSessionModal}
            centered
            className="m-3"
        >
            <Modal.Header closeButton className="m-3">
                <Modal.Title>Add Academic Session</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <div className="mb-3">
                    <Form.Label>Session Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="e.g. 2025-2026"
                        value={newSession.name}
                        isInvalid={!!sessionErrors.name}
                        onChange={(e) => {
                            setNewSession({
                                ...newSession,
                                name: e.target.value,
                            });

                            setSessionErrors((prev) => ({
                                ...prev,
                                name: undefined,
                            }));
                        }}
                    />

                    <Form.Control.Feedback type="invalid">
                        {sessionErrors.name?.[0]}
                    </Form.Control.Feedback>
                </div>

                <div className="mb-3">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                        type="date"
                        value={newSession.start_date}
                        isInvalid={!!sessionErrors.start_date}
                        onChange={(e) => {
                            setNewSession({
                                ...newSession,
                                start_date: e.target.value,
                            });

                            setSessionErrors((prev) => ({
                                ...prev,
                                start_date: undefined,
                            }));
                        }}
                    />

                    <Form.Control.Feedback type="invalid">
                        {sessionErrors.start_date?.[0]}
                    </Form.Control.Feedback>
                </div>

                <div className="mb-3">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                        type="date"
                        value={newSession.end_date}
                        isInvalid={!!sessionErrors.end_date}
                        onChange={(e) => {
                            setNewSession({
                                ...newSession,
                                end_date: e.target.value,
                            });

                            setSessionErrors((prev) => ({
                                ...prev,
                                end_date: undefined,
                            }));
                        }}
                    />

                    <Form.Control.Feedback type="invalid">
                        {sessionErrors.end_date?.[0]}
                    </Form.Control.Feedback>
                </div>

            </Modal.Body>

            <Modal.Footer className="m-3">
                <Button
                    variant="secondary"
                    onClick={closeSessionModal}
                >
                    Close
                </Button>

                <Button
                    variant="primary"
                    onClick={saveSession}
                >
                    Save Session
                </Button>
            </Modal.Footer>
        </Modal>
    )
}